import { render } from "./userForm.vue?vue&type=template&id=6e06e6a6&scoped=true"
import script from "./userForm.vue?vue&type=script&lang=js"
export * from "./userForm.vue?vue&type=script&lang=js"

import "./userForm.vue?vue&type=style&index=0&id=6e06e6a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e06e6a6"]])

export default __exports__